import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// `cn` is the standard shadcn/ui-style helper that lets components compose
// Tailwind classes without worrying about duplicates ("p-2 p-4" → "p-4").
// All UI primitives in src/components/ui/* and feature components funnel
// their `className` prop through this single helper.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
